import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/src/components/common/ConsultCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/src/components/member/ReviewOwnerActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/src/components/ui/AppImage.tsx");
